/**
 * Даты из API: на бэкенде храним UTC (naive `datetime.utcnow` в PostgreSQL как TIMESTAMP UTC).
 * В JSON часто приходит ISO без суффикса Z — в JS такая строка может парситься как *локальное* время.
 * Для сравнения инстантов и для `Intl` с `timeZone` пользователя всегда нормализуем к UTC.
 */
export function parseApiDateUtc(iso: string | null | undefined): Date | null {
  if (iso == null) return null
  const raw = String(iso).trim()
  if (!raw) return null
  const withT = raw.includes('T') ? raw : raw.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T')
  const hasZone =
    /[zZ]$/i.test(withT) ||
    /[+-]\d{2}:\d{2}$/.test(withT) ||
    /[+-]\d{2}\d{2}$/.test(withT)
  const normalized = hasZone ? withT : `${withT}Z`
  const d = new Date(normalized)
  return Number.isNaN(d.getTime()) ? null : d
}
